import React from 'react';
import { Grid } from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import { MediaStyles } from './styles';

type Props = {
  upload?: boolean;
};

const ProcessingMedia = ({ upload = false }: Props) => {
  const classes = MediaStyles();

  return (
    <Grid item>
      <div className={classes.loader}>
        <ScaleLoader color="#DCDEE5" css="animation-duration: 2s" loading />
      </div>
      <p className={classes.renderStatus}>
        {upload
          ? 'Uploading media'
          : 'Processing media'}
      </p>
    </Grid>
  );
};

export default ProcessingMedia;
